"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipientsSelectRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
/* eslint-disable import/named,import/namespace */
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var creatable_1 = tslib_1.__importDefault(require("react-select/creatable"));
var react_select_1 = require("react-select");
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var validate_1 = require("../../utils/validate");
var interfaces_1 = require("../../interfaces");
var scheduledMailRecipients_1 = require("../../utils/scheduledMailRecipients");
var MAXIMUM_RECIPIENTS_RECEIVE = 20;
var DELAY_TIME = 500;
var PADDING = 16;
var REMOVE_ICON_WIDTH = 21;
var LOADING_MENU_HEIGHT = 50;
var CREATE_OPTION = "create-option";
var SELECT_OPTION = "select-option";
var Menu = react_select_1.components.Menu, Input = react_select_1.components.Input;
var RecipientsSelectRendererUI = /** @class */ (function (_super) {
    tslib_1.__extends(RecipientsSelectRendererUI, _super);
    function RecipientsSelectRendererUI(props) {
        var _this = _super.call(this, props) || this;
        _this.recipientRef = react_1.default.createRef();
        _this.renderEmptyContainer = function () {
            return null;
        };
        _this.renderNoOptionsContainer = function (menuProps) {
            var inputValue = menuProps.selectProps.inputValue;
            if (inputValue) {
                return (react_1.default.createElement(sdk_ui_kit_1.Message, { className: "gd-recipient-existed s-gd-recipient-existed", type: "warning", contrast: true },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "options.menu.schedule.email.recipient.warning.existed" })));
            }
            return _this.renderEmptyContainer();
        };
        _this.renderMenuOptions = function (menuProps) {
            var _a = _this.props, isLoading = _a.isLoading, currentUser = _a.currentUser;
            var options = menuProps.options, getValue = menuProps.getValue, inputValue = menuProps.selectProps.inputValue;
            var selectedValues = getValue() || [];
            var selectedItemsCount = selectedValues.length;
            var areAllValuesSelected = options.length &&
                options.every(function (option) {
                    return (interfaces_1.isScheduleEmailExistingRecipient(option) && isEqual_1.default(option, currentUser)) ||
                        _this.isRecipientAdded(selectedValues, scheduledMailRecipients_1.getScheduledEmailRecipientEmail(option));
                });
            if (isLoading) {
                return _this.renderLoadingIcon(menuProps);
            }
            if (!inputValue && (selectedItemsCount >= MAXIMUM_RECIPIENTS_RECEIVE || areAllValuesSelected)) {
                return _this.renderEmptyContainer();
            }
            return _this.renderMenuOptionsContainer(menuProps);
        };
        _this.renderMenuOptionsContainer = function (menuProps) {
            return (react_1.default.createElement(Menu, tslib_1.__assign({ className: "s-gd-recipients-menu-container" }, menuProps), menuProps.children));
        };
        _this.renderLoadingIcon = function (menuProps) {
            return (react_1.default.createElement(Menu, tslib_1.__assign({ className: "s-gd-recipients-menu-container" }, menuProps),
                react_1.default.createElement(sdk_ui_kit_1.LoadingMask, { height: LOADING_MENU_HEIGHT })));
        };
        _this.renderOwnerValueContainer = function (value) {
            var isMulti = _this.props.isMulti;
            var selectTypeClassName = isMulti ? "multiple-value" : "single-value";
            return (react_1.default.createElement("div", { style: _this.getStyle(), className: "gd-recipient-value-item s-gd-recipient-value-item " + selectTypeClassName + " gd-owner-user" },
                react_1.default.createElement("div", { className: "gd-recipient-label" }, value)));
        };
        _this.renderMultiValueItemContainer = function (label, removeIcon) {
            return (react_1.default.createElement("div", { className: "gd-recipient-value-item s-gd-recipient-value-item multiple-value" },
                react_1.default.createElement("div", { style: _this.getStyle(), className: "gd-recipient-label" }, label),
                react_1.default.createElement("div", { className: "s-gd-recipient-remove" }, removeIcon)));
        };
        _this.renderErrorValueContainer = function (label, removeIcon) {
            return (react_1.default.createElement("div", { className: "gd-recipient-value-item s-gd-recipient-value-item multiple-value not-valid" },
                react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { className: "gd-recipient-not-valid-bubble", showDelay: 0, hideDelay: 0 },
                    react_1.default.createElement("div", { className: "recipient-item-not-valid" },
                        react_1.default.createElement("div", { style: _this.getStyle(), className: "gd-recipient-label" }, label),
                        react_1.default.createElement("div", { className: "s-gd-recipient-remove" }, removeIcon)),
                    react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-negative s-gd-recipient-not-valid-email", alignPoints: [{ align: "cr cl" }] },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "options.menu.schedule.email.recipient.invalid" })))));
        };
        _this.renderSingleValueContainer = function (singleValueProps) {
            var data = singleValueProps.data;
            var displayName = scheduledMailRecipients_1.getScheduledEmailRecipientDisplayName(data);
            return _this.renderOwnerValueContainer(displayName);
        };
        _this.renderMultiValueContainer = function (multiValueProps) {
            var data = multiValueProps.data, children = multiValueProps.children;
            // MultiValueRemove component from react-select
            var removeIcon = children[1];
            if (interfaces_1.isScheduleEmailExistingRecipient(data) && isEqual_1.default(data, _this.props.currentUser)) {
                return _this.renderOwnerValueContainer(scheduledMailRecipients_1.getScheduledEmailRecipientDisplayName(data));
            }
            var email = scheduledMailRecipients_1.getScheduledEmailRecipientEmail(data);
            if (!validate_1.isEmail(email)) {
                return _this.renderErrorValueContainer(email, removeIcon);
            }
            return _this.renderMultiValueItemContainer(email, removeIcon);
        };
        _this.renderOptionLabel = function (recipient) {
            var email = scheduledMailRecipients_1.getScheduledEmailRecipientEmail(recipient);
            var isExternalUser = interfaces_1.isScheduleEmailExternalRecipient(recipient);
            var isExternalUserMatchingExistingEmail = isExternalUser &&
                _this.props.options.some(function (option) { return scheduledMailRecipients_1.getScheduledEmailRecipientEmail(option) === email; });
            // When we are typing in react-select, it creates a new option on the background (check this.getNewOptionData)
            // To avoid displaying duplicities in the options, do not render external user option,
            // when it matches existing user email.
            if (isExternalUserMatchingExistingEmail) {
                return null;
            }
            // Render warning message, when it's an external user
            if (isExternalUser && validate_1.isEmail(email)) {
                return (
                // This class is necessary for testcafes
                react_1.default.createElement("div", { className: "s-gd-recipient-option-item s-recipient-not-in-workspace-warning" },
                    react_1.default.createElement(sdk_ui_kit_1.Message, { type: "warning", contrast: true },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "options.menu.schedule.email.recipient.warning.belong.workspace" }))));
            }
            return (react_1.default.createElement("div", { className: "gd-recipient-option-item s-gd-recipient-option-item" },
                react_1.default.createElement("span", { className: "gd-recipient-option-label-item s-gd-recipient-option-label-item" }, email),
                _this.renderRecipientValue(recipient)));
        };
        _this.getNewOptionData = function (inputValue) { return ({
            email: inputValue,
        }); };
        _this.renderRecipientValue = function (recipient) {
            var isExternalUser = interfaces_1.isScheduleEmailExternalRecipient(recipient);
            var email = scheduledMailRecipients_1.getScheduledEmailRecipientEmail(recipient);
            if (!isExternalUser && validate_1.isEmail(email)) {
                return (react_1.default.createElement("span", { className: "gd-recipient-option-value-item s-gd-recipient-option-value-item" }, scheduledMailRecipients_1.getScheduledEmailRecipientDisplayName(recipient)));
            }
            return _this.renderEmptyContainer();
        };
        _this.renderInputContainer = function (inputProps) {
            var isMulti = _this.props.isMulti;
            if (!isMulti) {
                return _this.renderEmptyContainer();
            }
            return (react_1.default.createElement("div", { className: "gd-recipient-input s-gd-recipient-input" },
                react_1.default.createElement(Input, tslib_1.__assign({}, inputProps))));
        };
        _this.handleOnChange = function (selectedValues, actionTypes) {
            var value = _this.props.value;
            var action = actionTypes.action;
            if (value.length >= MAXIMUM_RECIPIENTS_RECEIVE &&
                (action === CREATE_OPTION || action === SELECT_OPTION)) {
                _this.props.onChange(value);
                return;
            }
            if (selectedValues === null) {
                _this.props.onChange([value[0]]);
                return;
            }
            _this.props.onChange(selectedValues);
        };
        _this.loadUserListItems = function (searchString) {
            var _a = _this.props, options = _a.options, value = _a.value, canListUsersInProject = _a.canListUsersInProject, onLoad = _a.onLoad;
            var matchedUserList = _this.getMatchedRecipientEmails(options, searchString);
            var matchedUserListCount = matchedUserList.length;
            var isRecipientAdded = _this.isRecipientAdded(value, searchString);
            if (!canListUsersInProject || isRecipientAdded || matchedUserListCount > 0) {
                return;
            }
            _this.setState({ isLoading: true });
            onLoad({ search: searchString });
        };
        _this.onMenuOpen = function () {
            var _a = _this.props, onLoad = _a.onLoad, canListUsersInProject = _a.canListUsersInProject, options = _a.options;
            var userListCount = options.length;
            if (!userListCount && canListUsersInProject) {
                onLoad();
            }
        };
        _this.onSearch = function (searchString) {
            _this.loadUserListItems(searchString);
        };
        _this.isRecipientAdded = function (value, searchKey) {
            return value.some(function (recipient) {
                return isEqual_1.default(scheduledMailRecipients_1.getScheduledEmailRecipientUniqueIdentifier(recipient), searchKey);
            });
        };
        _this.onSearch = debounce_1.default(_this.onSearch, DELAY_TIME);
        return _this;
    }
    RecipientsSelectRendererUI.prototype.componentDidMount = function () {
        var current = this.recipientRef.current;
        if (!current) {
            return;
        }
        // update owner component style after recipient rendered
        var ownerContainer = current.querySelector(".gd-owner-user");
        var maxWidth = this.getStyle().maxWidth;
        if (ownerContainer) {
            ownerContainer.setAttribute("style", "max-width: " + maxWidth + "px");
        }
    };
    RecipientsSelectRendererUI.prototype.render = function () {
        var _a = this.props, intl = _a.intl, isMulti = _a.isMulti, options = _a.options, value = _a.value;
        var creatableSelectComponent = tslib_1.__assign(tslib_1.__assign({}, react_select_1.components), { IndicatorsContainer: this.renderEmptyContainer, Input: this.renderInputContainer, MultiValueContainer: this.renderMultiValueContainer, Menu: this.renderMenuOptions, Placeholder: this.renderEmptyContainer, SingleValue: this.renderSingleValueContainer, NoOptionsMessage: this.renderNoOptionsContainer });
        return (react_1.default.createElement("div", { className: "gd-input-component gd-recipients-field s-gd-schedule-email-dialog-recipients" },
            react_1.default.createElement("label", { className: "gd-label" }, intl.formatMessage({ id: "dialogs.schedule.email.to.label" })),
            react_1.default.createElement("div", { ref: this.recipientRef, className: "gd-input s-gd-recipients-value" },
                react_1.default.createElement(creatable_1.default, { cacheOptions: true, className: "gd-recipients-container", classNamePrefix: "gd-recipients", components: creatableSelectComponent, getNewOptionData: this.getNewOptionData, formatOptionLabel: this.renderOptionLabel, isClearable: false, isDisabled: !isMulti, isMulti: isMulti, onChange: this.handleOnChange, onInputChange: this.onSearch, onMenuOpen: this.onMenuOpen, options: options, value: value, getOptionValue: scheduledMailRecipients_1.getScheduledEmailRecipientUniqueIdentifier, getOptionLabel: scheduledMailRecipients_1.getScheduledEmailRecipientEmail }))));
    };
    RecipientsSelectRendererUI.prototype.getStyle = function () {
        var current = this.recipientRef.current;
        var width = (!isEmpty_1.default(current) && current.getBoundingClientRect()).width;
        // label item width equal value item container - padding - remove icon
        var recipientLabelWidth = width - PADDING - REMOVE_ICON_WIDTH;
        return {
            maxWidth: width ? recipientLabelWidth : "100%",
        };
    };
    RecipientsSelectRendererUI.prototype.getMatchedRecipientEmails = function (options, searchKey) {
        return searchKey
            ? options.filter(function (recipient) {
                return includes_1.default(scheduledMailRecipients_1.getScheduledEmailRecipientEmail(recipient), searchKey);
            })
            : [];
    };
    return RecipientsSelectRendererUI;
}(react_1.default.PureComponent));
exports.RecipientsSelectRenderer = react_intl_1.injectIntl(RecipientsSelectRendererUI);
//# sourceMappingURL=RecipientsSelectRenderer.js.map